// Error Boundary Configuration
export const ERROR_BOUNDARY_CONFIG = {
  // Global settings
  enableErrorDetails: process.env.NODE_ENV === 'development',
  enableConsoleLogging: true,
  enableRetryButton: true,

  // Default messages
  defaultMessages: {
    title: 'Something went wrong',
    message:
      'An unexpected error occurred. Please try again or contact support if the problem persists.',
    retryButtonText: 'Try Again',
    homeButtonText: 'Go to Dashboard',
    showDetailsButtonText: 'Show Error Details',
    hideDetailsButtonText: 'Hide Error Details',
  },

  // Component-specific error messages
  componentMessages: {
    websocket: {
      title: 'Connection Error',
      message:
        'Unable to establish real-time connection. Please check your network connection and try again.',
    },
    chart: {
      title: 'Chart Error',
      message:
        'Unable to render the chart. The data might be temporarily unavailable.',
    },
    api: {
      title: 'Data Loading Error',
      message:
        'Unable to load data from the server. Please check your connection and try again.',
    },
    auth: {
      title: 'Authentication Error',
      message:
        'There was an issue with authentication. Please try logging in again.',
    },
    table: {
      title: 'Table Error',
      message: 'Unable to display the data table. Please refresh the page.',
    },
  },
};

// Helper function to get error message by component type
export const getErrorMessage = (componentType) => {
  return (
    ERROR_BOUNDARY_CONFIG.componentMessages[componentType] ||
    ERROR_BOUNDARY_CONFIG.defaultMessages
  );
};

// Helper function to check if error details should be shown
export const shouldShowErrorDetails = () => {
  return ERROR_BOUNDARY_CONFIG.enableErrorDetails;
};

// Helper function for error reporting
export const reportError = (error, errorInfo, context = {}) => {
  if (ERROR_BOUNDARY_CONFIG.enableConsoleLogging) {
    console.error('Error Boundary:', error, errorInfo, context);
  }
};

export default ERROR_BOUNDARY_CONFIG;
